import { create } from 'zustand';

import { IUnit } from '@/models';
import { IUnitNerisUnassignedUnit } from '@/models/unit.neris';

interface UnitNerisState {
  assignedUnits: IUnit[];
  unassignedUnits: IUnitNerisUnassignedUnit[];
  loadingAssignedUnits: boolean;
  loadingUnassignedUnits: boolean;
  setAssignedUnits: (units: IUnit[]) => void;
  setUnassignedUnits: (units: IUnitNerisUnassignedUnit[]) => void;
  setLoadingAssignedUnits: (loading: boolean) => void;
  setLoadingUnassignedUnits: (loading: boolean) => void;
}

export const useUnitNerisStore = create<UnitNerisState>((set) => ({
  assignedUnits: [],
  unassignedUnits: [],
  loadingAssignedUnits: false,
  loadingUnassignedUnits: false,
  setAssignedUnits: (units) =>
    set({ assignedUnits: Array.isArray(units) ? units : [] }),
  setUnassignedUnits: (units) =>
    set({ unassignedUnits: Array.isArray(units) ? units : [] }),
  setLoadingAssignedUnits: (loading) => set({ loadingAssignedUnits: loading }),
  setLoadingUnassignedUnits: (loading) =>
    set({ loadingUnassignedUnits: loading }),
}));
